/** StakedCelo Manager — `toCelo(uint256)` returns the CELO owed for a
 *  given stCELO amount. Pass `1e18` to get the 1e18-scaled
 *  CELO-per-stCELO rate. Manager (Celo mainnet 42220):
 *  `0x0239b96D10a434a56CC9E09383077A0490cF9398`. */
export const StCeloManagerAbi = [
  {
    name: 'toCelo',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'stCeloAmount' }],
    outputs: [{ type: 'uint256' }],
  },
] as const
